export const PRESENCE_OPTIONS = [
    "Available",
    "Away",
    "BeRightBack",
    "Busy",
    "InAConferenceCall",
    "Inactive",
    "Offline",
    "InAMeeting",
    "OffWork",
    "OutOfOffice",
    "PresenceUnknown",
    "Presenting",
    "UrgentInterruptionsOnly",
    "InACall",
  ];
  